var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import '../../index.scss';
import { getMenuData, getMenuDataWithConfig } from '../../services/galaxy.service';
import Banner from '../Banner/Banner';
import Galaxy from '../Galaxy/Galaxy';
import Navigation from '../Navigation/Navigation';
/**
 * Menu
 */
var Menu = /** @class */ (function (_super) {
    __extends(Menu, _super);
    /**
     * Menu constructor
     *
     * @param props Menu properties
     */
    function Menu(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Open or close mobile menu
         *
         * @public
         */
        _this.toggleMobileMenu = function () {
            var mobileMenuIsOpen = _this.state.mobileMenuIsOpen;
            _this.setState({ mobileMenuIsOpen: !mobileMenuIsOpen });
        };
        /**
         * Display search bar and defined on click action on search
         *
         * @public
         * @param searchConfig
         */
        _this.enableSearch = function (searchConfig) {
            _this.setState({ searchConfig: searchConfig });
        };
        /**
         * Display login state of menu
         *
         * @public
         * @param isLogged
         */
        _this.handleLogin = function (isLogged) {
            if (isLogged === void 0) { isLogged = true; }
            _this.setState({ isLogged: isLogged });
        };
        /**
         * Return true if menu can be display
         */
        _this.checkMenuCanBeDisplay = function () {
            return !!_this.state.navigationMenu.length && !!_this.state.galaxyMenu;
        };
        var _a = _this.props, isLogged = _a.isLogged, service = _a.service;
        _this.state = {
            galaxyMenu: [],
            isLoading: true,
            isLogged: !!isLogged,
            loggedMenu: [],
            loggedOutMenu: [],
            mobileMenuIsOpen: false,
            navigationMenu: [],
            newsMenu: [],
            service: service,
        };
        return _this;
    }
    /**
     * Component initialisation
     */
    Menu.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var menuGroup, menuGroup;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.props.menuGroup) return [3 /*break*/, 1];
                        this.setState(__assign(__assign({}, this.props.menuGroup), { isLoading: false }));
                        return [3 /*break*/, 5];
                    case 1:
                        if (!this.props.config) return [3 /*break*/, 3];
                        return [4 /*yield*/, getMenuDataWithConfig(this.state.service, this.props.config)];
                    case 2:
                        menuGroup = _a.sent();
                        this.setState(__assign(__assign({}, menuGroup), { isLoading: false }));
                        return [3 /*break*/, 5];
                    case 3:
                        if (!this.state.service) return [3 /*break*/, 5];
                        return [4 /*yield*/, getMenuData(this.state.service)];
                    case 4:
                        menuGroup = _a.sent();
                        this.setState(__assign(__assign({}, menuGroup), { isLoading: false }));
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Menu.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.isLogged !== prevProps.isLogged) {
            this.setState({ isLogged: !!this.props.isLogged });
        }
    };
    /**
     * Component render method
     */
    Menu.prototype.render = function () {
        var _a = this.props, searchConfig = _a.searchConfig, getLinkUrlParams = _a.getLinkUrlParams;
        var _b = this.state, isLoading = _b.isLoading, galaxyMenu = _b.galaxyMenu, navigationMenu = _b.navigationMenu, loggedMenu = _b.loggedMenu, loggedOutMenu = _b.loggedOutMenu, newsMenu = _b.newsMenu, mobileMenuIsOpen = _b.mobileMenuIsOpen, service = _b.service, isLogged = _b.isLogged;
        if (isLoading || !this.checkMenuCanBeDisplay()) {
            return React.createElement("div", null);
        }
        return (React.createElement("div", { className: "galaxy-navigation" },
            React.createElement(Navigation, { categories: navigationMenu, mobileMenuIsOpen: mobileMenuIsOpen }),
            React.createElement(Banner, { services: galaxyMenu, menu: isLogged ? loggedMenu : loggedOutMenu, news: newsMenu, mobileMenuIsOpen: mobileMenuIsOpen, toggleMobileMenu: this.toggleMobileMenu, isLogged: isLogged, searchConfig: searchConfig, getLinkUrlParams: getLinkUrlParams }),
            React.createElement(Galaxy, __assign({}, { galaxyMenu: galaxyMenu, service: service }))));
    };
    return Menu;
}(React.Component));
export default Menu;
//# sourceMappingURL=Menu.js.map